module.exports = __webpack_public_path__ + "img/98_6.6b7bb4b6.png";